import { Button, DialogActions, DialogContent, DialogTitle, TextField, TunaDialog, Typography } from '@tunasong/ui-lib'
import type { FC, FormEvent } from 'react'
import { useId, useState } from 'react'

export interface NewGroupDialogProps {
  /** Prefilled and selected, so typing replaces it and Enter keeps it. */
  defaultName: string
  /** Shown under the name field, e.g. that the option's picks move with it. */
  text?: string
  onCancel(): void
  onCreate(name: string): void
}

/**
 * Names a group created from an option row's Group select, so the owner does not have to scroll to the new group's
 * name field afterwards. Mount it only while open: its name starts from `defaultName` each time.
 */
export const NewGroupDialog: FC<NewGroupDialogProps> = props => {
  const { defaultName, text, onCancel, onCreate } = props
  const [name, setName] = useState(defaultName)
  const titleId = useId()
  const trimmed = name.trim()

  const handleSubmit = (ev: FormEvent) => {
    ev.preventDefault()
    if (trimmed) {
      onCreate(trimmed)
    }
  }

  return (
    <TunaDialog open={true} onClose={onCancel} maxWidth="xs" fullWidth={true} aria-labelledby={titleId}>
      <form onSubmit={handleSubmit}>
        <DialogTitle id={titleId} onClose={onCancel}>
          New group
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Group name"
            aria-label="Group name"
            value={name}
            onChange={ev => setName(ev.target.value)}
            onFocus={ev => ev.target.select()}
            fullWidth={true}
          />
          {text ? <Typography variant="body2">{text}</Typography> : null}
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" disabled={!trimmed}>
            Create group
          </Button>
        </DialogActions>
      </form>
    </TunaDialog>
  )
}

export default NewGroupDialog
